import styled, { css } from 'styled-components';
import { mobileMaxWidth } from '../../utils/constants';

export const InputNumber = styled.input`
  ${(props) => (props.showError ? css`
      border-width: 0.1rem 0.1rem 0.1rem;
      border-style: solid;
      border-color: #D81118;
    ` : css`
      border-width: 0.1rem;
      border-style: solid;
      border-color: #999;
    `
)}
`;

export const Label = styled.label`
  font-size: 1.4rem;
  font-weight: 600;
`;

export const ErrorMessage = styled.span`
  padding-top: 0.6rem;
  color: #D81118;
  display: ${(props) => (props.showError ? 'block' : 'none')};

  @media all and (max-width: ${mobileMaxWidth}){
    font-size: 1.1rem;
  }
`;
